import React, { useState } from 'react';
import './AmbassadorClubRegister.css';
import { Helmet } from 'react-helmet-async';

const AmbassadorClubRegister = () => {
  const [formData, setFormData] = useState({});
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({ ...formData, [name]: files ? files[0] : value });
  };

  const [loading, setLoading] = useState(false);

const handleSubmit = async (e) => {
  e.preventDefault();
  if (loading) return;
  setLoading(true);

  const data = new FormData();
  Object.keys(formData).forEach((key) => data.append(key, formData[key]));

  try {
    const response = await fetch(
      'https://esmaaash.in/esmaaash_web/backend/register_ambassador.php',
      { method: 'POST', body: data }
    );

    // ✅ Read body only once
    const text = await response.text();

    let result;
    try {
      result = JSON.parse(text);
    } catch (parseError) {
      console.error('Invalid JSON response from server:', text);
      alert('Server returned invalid response. Please contact admin.');
      return;
    }

    if (result.status === 'success') {
      setSuccess(true);
    } else {
      alert('Failed: ' + (result.message || 'Unknown error'));
    }
  } catch (error) {
    console.error('Submit error:', error);
    alert('Something went wrong. Please try again.');
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="register-container">
      {/* ✅ SEO Meta Tags */}
      <Helmet>
        <title>Smaaash Ambassador Club Registration | Apply Now</title>
        <meta
          name="description"
          content="Register to become a Smaaash Ambassador! Fill out the form to join the campus ambassador program, unlock perks, and represent Smaaash at your college."
        />
        <meta name="keywords" content="Smaaash Ambassador, college ambassador registration, gaming credits, student ambassador program, apply now" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://esmaaash.in/AmbassadorClubRegister" />

        {/* Open Graph */}
        <meta property="og:title" content="Smaaash Ambassador Club Registration | Apply Now" />
        <meta property="og:description" content="Register to become a Smaaash Ambassador! Fill out the form to join the campus ambassador program." />
        <meta property="og:image" content="https://esmaaash.in/esmaaash_web/uploads/Smaaash_Ambasador_Logo.mp4" />
        <meta property="og:url" content="https://esmaaash.in/AmbassadorClubRegister" />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Smaaash Ambassador Club Registration | Apply Now" />
        <meta name="twitter:description" content="Register to become a Smaaash Ambassador! Fill out the form to join the campus ambassador program." />
        <meta name="twitter:image" content="https://esmaaash.in/esmaaash_web/uploads/Smaaash_Ambasador_Logo.mp4" />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "EducationalOrganization",
            "name": "Smaaash Ambassador Club",
            "url": "https://esmaaash.in/AmbassadorClubRegister",
            "description": "Register to become a Smaaash Ambassador! Fill out the form to join the campus ambassador program.",
            "logo": "https://esmaaash.in/esmaaash_web/uploads/Smaaash_Ambasador_Logo.mp4"
          }
          `}
        </script>
      </Helmet>

      <h2>Ambassador Club Registration</h2>
       {/* ✅ Show thank-you message if success, else show form */}
      {success ? (
        <div className="success-message">
          🎉 Thank you for your registration! We value your time and appreciate your interest. You will be notified once you are selected.
        </div>
      ) : (
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <input className="form-input" type="text" name="first_name" placeholder="First Name *" onChange={handleChange} required />
        <input className="form-input" type="text" name="last_name" placeholder="Last Name *" onChange={handleChange} required />
        <input className="form-input" type="text" name="mobile_number" placeholder="Mobile Number *" onChange={handleChange} required />
        <input className="form-input" type="text" name="college_name" placeholder="College/University Name *" onChange={handleChange} required />
        <input className="form-input" type="text" name="city" placeholder="City *" onChange={handleChange} required />
        <input className="form-input" type="email" name="email" placeholder="Email *" onChange={handleChange} required />
        <input className="form-input" type="text" name="referral_code" placeholder="Referral Code" onChange={handleChange} />

        <textarea
          className="form-textarea"
          name="reason_to_join"
          placeholder="Why do you want to join Smaaash Ambassador Club? *"
          onChange={handleChange}
          required
        ></textarea>

        <textarea
          className="form-textarea"
          name="stand_out"
          placeholder="What makes you stand out? *"
          onChange={handleChange}
          required
        ></textarea>

        <label>Are you involved in organizing or participating in college fests, sports events, or debates? *</label>
        <select className="form-select" name="college_activities" onChange={handleChange} required>
          <option value="">-- Select an option --</option>
          <option value="organize_lead">Actively organize and lead events – I'm always in the thick of planning and coordinating.</option>
          <option value="regular_participant">Regular participant – I love being on stage or competing.</option>
          <option value="helper">I help out where needed and ensure things run smoothly.</option>
          <option value="occasional">I participate occasionally, but only in events that align with my interests.</option>
          <option value="not_involved">Not involved – I focus on other areas of college life.</option>
        </select>

        <label>What's your go-to game, sport or activity when it's time to blow off some steam? *</label>
        <select className="form-select" name="favorite_game" onChange={handleChange} required>
          <option value="">-- Select an option --</option>
          <option value="outdoor_sports">Outdoor sports (football, cricket, basketball, etc.)</option>
          <option value="e_gaming">E-Gaming (BGMI, FIFA, Valorant, Free Fire, etc.)</option>
          <option value="creative">Creative outlets (painting, music, dancing, designing)</option>
          <option value="social_media">Social media activities (content creation, video editing, marketing, etc.)</option>
          <option value="socializing">Hanging out with friends or socializing</option>
          <option value="me_time">Me-time with shows, books, or chill activities</option>
        </select>

        <label>Which platform are you most active on? *</label>
        <select
          className="form-select"
          name="most_active_platform"
          onChange={handleChange}
          value={formData.most_active_platform}
          required
        >
          <option value="">-- Select an option --</option>
          <option value="instagram">Instagram</option>
          <option value="youtube">YouTube</option>
          <option value="linkedin">LinkedIn</option>
          <option value="x">X (formerly Twitter)</option>
          <option value="others">Others</option>
          <option value="not_active">I’m not active on any platform</option>
        </select>

        {formData.most_active_platform === 'others' && (
          <input
            className="form-input"
            type="text"
            name="other_platform"
            placeholder="Please specify the platform"
            onChange={handleChange}
            required
          />
        )}

        <label>Roughly how many followers do you have on your main platform? *</label>
        <select className="form-select" name="follower_range" onChange={handleChange} required>
          <option value="">-- Select an option --</option>
          <option value="0_500">0 - 500</option>
          <option value="500_2000">500 - 2000</option>
          <option value="2000_5000">2K - 5K</option>
          <option value="5000_10000">5K - 10K</option>
          <option value="10000_30000">10K - 30K</option>
          <option value="30000_plus">30K+</option>
        </select>

        <label>Student ID Card *</label>
        <input className="form-input" type="file" name="student_id_card" accept="image/*,.pdf" onChange={handleChange} required />

<button type="submit" disabled={loading}>
  {loading ? "Submitting..." : "Submit"}
</button>
      </form>
       )}
    </div>
  );
};

export default AmbassadorClubRegister;
